<template>
  <div class="transportation-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="transportation-content">
      <h4 class="transportation-h4 indent" id="transportation-7">МОРСКИ ТРАНСПОРТ</h4>
      <p class="transportation-p indent">Употребата на алуминия в морския транспорт може да доведе до повишаване скоростта и размера на лодките, яхтите, фериботите и корабите, докато в същото време подобри икономията на гориво, плавателността, сигурността, надвежността, както и разходите за поддръжка.</p>

      <div class="transportation-img" :style="{backgroundImage: 'url(' + '/static/img/markets/transportation/img_6.jpg' + ')'}"></div>
      <h4 class="transportation-h4 indent" id="transportation-8">РЕЛСОВ ТРАНСПОРТ</h4>
      <p class="transportation-p indent">Използването на алуминий в леките автомобили позволява на производителите са съкратят една трета от теглото на превозното средство в сравнение с тези, при които се използва стомана. В бързите транзити и крайградски железопътни системи, където влаковете трябва да правят много спирания, могат да бъдат постигнати значителни икономии, тъй като е необходимо по-малко енергия за ускоряване и спиране с алуминиеви автомобили. В допълнение, алуминиевите коли са по-лесни за производство и съдържат по-малко елементи. </p>

      <div class="transportation-img" :style="{backgroundImage: 'url(' + '/static/img/markets/transportation/img_7.jpg' + ')'}"></div>
      <h4 class="transportation-h4 indent" id="transportation-9">ПРЕВОЗНИ СРЕДСТВА С ТЪРГОВСКА ЦЕЛ</h4>
      <p class="transportation-p indent">Алуминият намалява теглото на превозното средство. При транспортиране на товари с висока плътност, което обикновено насища максималното общо тегло на автомобила, алуминият позволява товаренето на повече стоки. Това води до допълнителен доход и / или по-висока конкурентоспособност, като в същото време намалява емисиите на CO2. </p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["transportation-7", "Морски транспорт"],
        ["transportation-8", "Релсов транспорт"],
        ["transportation-9", "Превозни средства с търговска цел"]
      ]
    };
  }
};
</script>

<style scoped>
.transportation-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.transportation-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.transportation-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.transportation-link {
  font-size: 19px;
  text-decoration: underline;
}
.transportation-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.transportation-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .transportation-content {
    width: 100%;
  }
  .transportation-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .transportation-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .transportation-link {
    font-size: 16px;
  }
  .transportation-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Transportation.vue